exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:599px){home-slider .carousel{height:272px!important}}@media (min-width:600px){home-slider .carousel{height:460px!important}}@media (min-width:900px){home-slider .carousel{height:650px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/home/slider/home-slider.styl
// module id = 783
// module chunks = 0